import { render } from "./PageFooterPreview.vue?vue&type=template&id=40e08feb&scoped=true"
import script from "./PageFooterPreview.vue?vue&type=script&lang=js"
export * from "./PageFooterPreview.vue?vue&type=script&lang=js"

import "./PageFooterPreview.vue?vue&type=style&index=0&id=40e08feb&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40e08feb"]])

export default __exports__